import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'bread-crumb',
  templateUrl: './bread-crumb.component.html',
  styleUrls: ['./bread-crumb.component.css']
})
export class BreadCrumbComponent implements OnInit {

  @Input() items: Array<string> = [];
  // Função opcional que pode ser passada pelo pai
  @Input() onItemClick?: (item: any, index: number) => void;

  constructor() { }

  ngOnInit(): void {
  }

  isTheLastItem(item: string): boolean {
    const index = this.items.indexOf(item);
    return index + 1 === this.items.length;
  }
  
 
  handleItemClick(item: any, index: number): void {
    // Só chama se a função foi passada
    if (this.onItemClick) {
      this.onItemClick(item, index);
    }
  }

}
